import { PolicyCheckCompany } from "../../api/policyCheck";
import { RequestTablePagination } from "../RequestTable/RequestTablePagination";
import "../RequestTable/RequestTable.scss";

interface PolicyCheckTableProps {
  data: PolicyCheckCompany[];
  page: number;
  pageSize: number;
  totalPages: number;
  onRowClick: (item: PolicyCheckCompany) => void;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

export const PolicyCheckTable = ({
  data,
  page,
  pageSize,
  totalPages,
  onRowClick,
  onPageChange,
  onPageSizeChange,
}: PolicyCheckTableProps) => {
  const safeTotalPages = Math.max(1, totalPages);
  const canGoNext = page + 1 < safeTotalPages;

  return (
    <div className="request-table-wrapper">
      <div className="request-table-card">
        <table className="request-table">
          <thead>
            <tr>
              <th>Компания</th>
              <th>ИНН</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={2} className="request-table-empty">
                  Нет данных
                </td>
              </tr>
            ) : (
              data.map((item) => (
                <tr
                  key={item.id}
                  className="request-table-row-clickable"
                  onClick={() => onRowClick(item)}
                >
                  <td>{item.companyName?.trim() || "—"}</td>
                  <td>{item.inn?.trim() || "—"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <RequestTablePagination
        page={page}
        pageSize={pageSize}
        totalPages={safeTotalPages}
        canGoNext={canGoNext}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
};
